import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=cb68a702&scoped=true"
import script from "./GroupRow.vue?vue&type=script&lang=ts"
export * from "./GroupRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb68a702",
  null
  
)

export default component.exports